export default "__VITE_ASSET__BJMtd_hd__"